<template>
  <div id="map" class="mapContainer"></div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "CustomMap",
  props: ["address"],
  data: function () {
    return {
        myLatLng: { lat: 46.86243165567067, lng: 8.628976468607762 },
        map: null
    };
  },
  methods: {
 
  },
  mounted() {
    let map = new window.google.maps.Map(document.getElementById('map'), {
      center: this.myLatLng,
      zoom: 15,
      mapId: 'd71cfeb82d2e6afc'
    })

    new window.google.maps.Marker({
      position: this.myLatLng,
      map,
      title: "Tourismuskommission Attinghausen",
      icon: {
        url: "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
      }
    });
  },
});
</script>
